import Api from '@/services/Api';
import store from '@/store';

export default {
  register(credintials) {
    return Api().post('api/register', credintials, {
      headers: {
        Authorization: 'Bearer ' + store.getters.getToken,
      },
    });
  },
  changePassword(credintials) {
    return Api().post('api/change-password_', credintials, {
      headers: {
        Authorization: 'Bearer ' + store.getters.getToken,
      },
    });
  },
  changeUserPassword(credintials) {
    return Api().post('api/change-user-password', credintials, {
      headers: {
        Authorization: 'Bearer ' + store.getters.getToken,
      },
    });
  },

  login(credintials) {
    return Api().post('/', credintials);
  },
};

// AuthenticationService.register({
//     email:'testi@testi.fi',
//     passsword: '1234455'
// })
